export default "__VITE_ASSET__501cb1bc__"